<script setup lang="ts">
import Button from '~/components/design-system/button.vue';

const expandedContent = ref<boolean>(false);
const route = useRoute();

const contentPath = computed(() => {
  if (!!route.params.contentType)
    return route.params?.game === 'aviator'
      ? '/aviator'
      : String(route.params.contentType);
  return '/';
});
</script>

<template>
  <div :key="contentPath" class="container">
    <div :class="{ 'seo mt-2': true, 'seo-wrapper': !expandedContent }">
      <kentico-shadow :content="contentPath" seo-content />
    </div>
    <div class="w-full flex justify-center">
      <Button type="transparent" @click="expandedContent = !expandedContent">
        {{ expandedContent ? $t('show-less') : $t('show-all') }}
      </Button>
    </div>
    <div id="scripts-holder" />
  </div>
</template>

<style scoped lang="scss">
.header {
  border: 1px solid #dae0ed;
  border-bottom: 0px;
  @media screen and (min-width: 561px) {
    border: 0px;
    border-bottom: 1px solid #dae0ed;
  }
}
.dark {
  .header {
    border-color: #464f60;
  }
}
.seo-wrapper {
  max-height: 200px;
  overflow: hidden;
  position: relative;
  &.seo-large {
    max-height: 780px;
    @media (max-width: 767px) {
      max-height: 120vh;
    }
    @media (max-width: 390px) {
      max-height: 75vh;
    }
  }
  &:after {
    content: '';
    background-image: linear-gradient(
      to bottom,
      rgba(240, 240, 242, 0.33) 9.25%,
      rgba(248, 248, 249, 1) 88.9%
    );
    position: absolute;
    height: 50px;
    right: 0;
    bottom: 0;
    left: 0;
    .dark & {
      background-image: linear-gradient(
        to bottom,
        rgba(19, 19, 22, 0) 7.25%,
        #131316 98%
      );
    }
  }
}
</style>
<style lang="scss">
.panel-collapse:focus-visible {
  outline: none;
}
.accordion-active {
  scroll-margin-top: 125px;
}
</style>
